<div class="content">
  <app-header [sidenavOpened]="sidenav.opened" (sidenavToggle)="onToggleSidenav($event)"></app-header>
  <div class="content__main">
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav class="sidenav" mode="over" [opened]="isSidenavOpened" (openedChange)="onToggleSidenav($event)" #sidenav>
        <mat-nav-list>
          <!-- <a mat-list-item (click)="goToProfileSettings()">Profile Settings</a> -->
          <a mat-list-item (click)="signOut()">Sign Out</a>
        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content id="sidenav-content">
        <ngx-spinner name="app-spinner" type="ball-scale-multiple" size="medium" bdColor="rgba(255,255,255,1)" color="rgba(0,0,0,1)"></ngx-spinner>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
    <!--  
    <div class="center-content mb-5" style="background-color: #fff; margin-top: -50px">
      <app-footer fontColor="#000" *ngIf="showElementsNoLandingPage"></app-footer>
    </div> 
    -->
  </div>
</div>
